import { buildCommerceOfferId, isCommerceOffer } from '@themaven-net/commerce-shared';
import { html, nothing } from 'lit';
/**
 * Build the button details for a set of commerce offers based on the supplied options
 */
export function buildAllButtonDetails(offers, options, defaultButtonText) {
    return offers.map((offer) => buildButtonDetails(offer, options, defaultButtonText));
}
/**
 * Build the button details for a single commerce offer based on the supplied options
 */
export function buildButtonDetails(offer, options, defaultButtonText) {
    return { offer, text: buildOfferButtonText(offer, options, defaultButtonText) };
}
/**
 * Determine the proper button text for an offer
 *
 * This will also replace any data slugs in the text
 * @todo add dynamic token replacement here
 */
export function buildOfferButtonText(offer, options, defaultButtonText) {
    const offerId = buildCommerceOfferId(offer);
    let text = defaultButtonText;
    if (options.buttonTitleByIdentifier !== undefined &&
        options.buttonTitleByIdentifier[offerId] !== undefined) {
        text = options.buttonTitleByIdentifier[offerId];
    }
    return text;
}
/**
 * Render a commerce link element using the supplied config
 *
 * This method allows for easy addition of defaults to config links
 */
export function renderCommerceLink(contents, linkDestination, item, options, hidden = false, extraAttributes, classes) {
    if (linkDestination === undefined) {
        return html `${contents}`;
    }
    classes ?? (classes = '');
    const config = { item, options };
    if (isCommerceOffer(linkDestination)) {
        config.offer = linkDestination;
    }
    return html `<commerce-link
        classnames="${classes}"
        href="${typeof linkDestination === 'string' ? linkDestination : nothing}"
        rel="nofollow noopener noreferrer"
        target="_blank"
        .dynamicAttrs=${extraAttributes}
        .config=${config}
        ?hidden=${hidden}
        >${contents}</commerce-link
    >`;
}
export function renderCommerceCta(offerDetails, item, options, classes, linkExtraAttributes, linkClasses) {
    if (offerDetails === undefined || offerDetails.text === undefined) {
        return html ``;
    }
    const link = renderCommerceLink(offerDetails.text, offerDetails.offer, item, options, false, linkExtraAttributes, linkClasses);
    // rely on slot adoption as it is cleaner
    return html `<commerce-cta classes="${classes ?? ''}">${link}</commerce-cta>`;
}
//# sourceMappingURL=utility.js.map